import { Helmet } from "react-helmet";
import { Outlet } from "react-router-dom";

export const MainLayout = () => {
  return (
    <>
      <Helmet>
        <html className="m-0 p-0" />
        <body className="min-h-screen m-0 p-0 font-sans box-border" />
      </Helmet>
      <Outlet />
    </>
  );
};
